import React, { useState, useEffect } from "react";
import QRCode from "qrcode";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import { FaEdit, FaTrash } from "react-icons/fa";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "../../assets/css/GuestMaster.css";
import function1 from "../../assets/images/function1.svg";
import { getMainGuestsAndAttendees } from "../../utils/getGuestWithAttendees";
import { useSelector } from "react-redux";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import {
  getOccasionsByEventId,
  updateOccasionCount,
  guestAllocation,
  trackInvites,
  getTrackedInvites,
} from "../../server/Api";
import { fetchAllocations } from "../../utils/getAllocatedGuestAndAttendees";
import * as XLSX from "sheetjs-style";

import axios from "axios";
import { canEditPage } from "../../utils/pagePermissions";

const RSVP = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [guestWithAttendees, setGuestWithAttendees] = useState([]);
  const [occasions, setOccasions] = useState([]);
  const selectedEvent = useSelector((state) => state.auth.selectedEvent);
  const eventEntity = useSelector((state) => state.auth.user);
  const canEdit = canEditPage(selectedEvent, "track-invites", eventEntity);
  const [selectedAllocations, setSelectedAllocations] = useState({});
  const [regNoMap, setRegNoMap] = useState({});
  const [responseMap, setResponseMap] = useState({});
  const navigate = useNavigate();
  // Fetch occasions
useEffect(() => {
  const fetchOccasions = async () => {
    try {
      if (!selectedEvent?.eventId) return;
      const url = getOccasionsByEventId(selectedEvent.eventId);
      const res = await axios.get(url);

      // Keep old filter: RSVP true
      const rsvpOccasions = res.data.data.filter(occ => occ.RSVP === true);

      // New filter: only active occasions
      const filteredOccasions = rsvpOccasions.filter(
        (occ) => occ.isOccasionActive
      );

      setOccasions(filteredOccasions);
    } catch (error) {
      console.error("Failed to fetch occasions", error);
      if (error.response?.status !== 404) {
        toast.error("Failed to load occasions");
      }
      setOccasions([]);
    }
  };

  fetchOccasions();
}, [selectedEvent]);



  useEffect(() => {
    const loadAllocationAndResponses = async () => {
      if (!selectedEvent?.eventId) return;

      try {
        const { formatted, regNoMap } = await fetchAllocations(
          selectedEvent.eventId
        );
        setSelectedAllocations(formatted);
        setRegNoMap(regNoMap);

        const res = await axios.get(getTrackedInvites(selectedEvent.eventId));
        const trackData = res.data?.data || [];
        const trackResponses = {};

        trackData.forEach((invite) => {
          const key = `${invite.guestId}-${invite.attendeeId || "null"}`;
          const allocatedIds = formatted[key] || [];
          const allocatedIdSet = new Set(allocatedIds.map((id) => String(id)));

          const occResponses = {};
          (invite.rsvps || []).forEach((r) => {
            const occId = r.occasionId;
            if (allocatedIdSet.has(String(occId))) {
              occResponses[occId] =
                r.response === "N/A" ? null : r.response;
            }
          });

          trackResponses[key] = occResponses;
        });

        setResponseMap(trackResponses);
      } catch (error) {
        console.error("Failed to load RSVP data", error);
        toast.error("Failed to load RSVP data.");
      }
    };

    loadAllocationAndResponses();
  }, [selectedEvent]);
  useEffect(() => {
    const fetchGuests = async () => {
      try {
        if (!selectedEvent?.eventId) return;
        const data = await getMainGuestsAndAttendees(selectedEvent.eventId);
        setGuestWithAttendees(data);
        console.log("Guest & Attendee list fetched successfully:", data);
      } catch (error) {
        console.error("Error fetching guest & attendee list:", error);
        toast.error("Failed to fetch guest & attendee list.");
      }
    };

    fetchGuests();
  }, [selectedEvent]);

  const getFullName = (guest) => {
    return [guest.prefix, guest.firstName, guest.middleName, guest.lastName]
      .filter(Boolean)
      .join(" ");
  };

  const isSameId = (left, right) => String(left) === String(right);

  const isAllocatedToOccasion = (allocations = [], occasionId) =>
    allocations.some((occId) => isSameId(occId, occasionId));

  const getRsvpAllocatedOccasions = (key) =>
    (selectedAllocations[key] || []).filter((occId) =>
      occasions.some((occ) => isSameId(occ._id, occId) && occ.RSVP === true)
    );

  const hasRSVPAllocatedOccasion = (key) =>
    getRsvpAllocatedOccasions(key).length > 0;

  const totalGuests = guestWithAttendees.length;
  const totalAttendees = guestWithAttendees.reduce(
    (sum, entry) => sum + (entry.attendees?.length || 0),
    0
  );

  const TotalGuestCount = totalGuests + totalAttendees;

  const handleSelectAllResponses = (guestId, attendeeId, checked) => {
    const key = `${guestId}-${attendeeId || "null"}`;
    const allocatedOccasions = getRsvpAllocatedOccasions(key);

    setResponseMap((prev) => {
      const currentResponses = prev[key] || {};

      // if user clicks "checked" but all already yes, toggle to null
      const allYes =
        allocatedOccasions.length > 0 &&
        allocatedOccasions.every((occId) => currentResponses[occId] === "yes");

      let newResponses = {};
      if (allYes) {
        // toggle off → clear all responses
        newResponses = {};
      } else if (checked) {
        // set all allocated to yes
        newResponses = allocatedOccasions.reduce(
          (acc, occId) => ({ ...acc, [occId]: "yes" }),
          {}
        );
      }

      return {
        ...prev,
        [key]: newResponses,
      };
    });
  };

  const setPersonOccasionResponse = (personKey, occasionId, value) => {
    setResponseMap((prev) => {
      const current = prev[personKey]?.[occasionId] || null;
      const nextValue = current === value ? null : value;
      return {
        ...prev,
        [personKey]: {
          ...(prev[personKey] || {}),
          [occasionId]: nextValue,
        },
      };
    });
  };

  const renderRsvpChoice = (personKey, occasionId, response) => {
    const isViewer = !canEdit;
    return (
      <div className="rsvp-choice" role="group" aria-label="RSVP response">
        <button
          type="button"
          className={`rsvp-choice-btn rsvp-choice-yes${
            response === "yes" ? " is-active" : ""
          }`}
          disabled={isViewer}
          aria-pressed={response === "yes"}
          onClick={() => setPersonOccasionResponse(personKey, occasionId, "yes")}
        >
          Yes
        </button>
        <button
          type="button"
          className={`rsvp-choice-btn rsvp-choice-no${
            response === "no" ? " is-active" : ""
          }`}
          disabled={isViewer}
          aria-pressed={response === "no"}
          onClick={() => setPersonOccasionResponse(personKey, occasionId, "no")}
        >
          No
        </button>
      </div>
    );
  };

  const handleSubmit = async () => {
    const payloads = [];

    guestWithAttendees.forEach((entry) => {
      const mainGuest = entry.guest;
      const attendees = entry.attendees || [];
      const mainKey = `${mainGuest._id}-null`;

      const buildRsvps = (key, allocatedOccasions) => {
        return allocatedOccasions
          .filter((occId) =>
            occasions.some((occ) => isSameId(occ._id, occId) && occ.RSVP === true)
          )
          .map((occId) => {
            const responses = responseMap[key] || {};
            const response = responses[occId] ?? null;

            return {
              occasionId: occId,
              response,
              respondedAt: response ? new Date().toISOString() : null,
            };
          })
          .filter((rsvp) => rsvp.response === "yes" || rsvp.response === "no");
      };

      const mainAllocatedOccasions = getRsvpAllocatedOccasions(mainKey);
      if (mainAllocatedOccasions.length > 0) {
        const rsvps = buildRsvps(mainKey, mainAllocatedOccasions);

        payloads.push({
          eventId: selectedEvent?.eventId,
          guestId: mainGuest._id,
          attendeeId: null,
          confirmedOccasionIds: mainAllocatedOccasions,
          rsvps,
          demographic: "Adult",
          gender: mainGuest.gender || "",
          foodPreference: mainGuest.foodPreference || "",
          allergic: mainGuest.allergic || "",
          specialNeeds: mainGuest.specialNeeds || "",
          specialRequest: mainGuest.specialRequest || "",
          enteredBy: eventEntity?.username || "admin",
          modifiedBy: eventEntity?.username || "admin",
        });
      }

      attendees.forEach((attendee) => {
        const key = `${mainGuest._id}-${attendee._id}`;
        const allocatedOccasions = getRsvpAllocatedOccasions(key);

        if (allocatedOccasions.length > 0) {
          const rsvps = buildRsvps(key, allocatedOccasions);

          payloads.push({
            eventId: selectedEvent?.eventId,
            guestId: mainGuest._id,
            attendeeId: attendee._id,
            confirmedOccasionIds: allocatedOccasions,
            rsvps,
            demographic: attendee.demographic || "",
            gender: attendee.gender || "",
            foodPreference: attendee.foodPreference || "",
            allergic: attendee.allergic || "",
            specialNeeds: attendee.specialNeeds || "",
            specialRequest: attendee.specialRequest || "",
            enteredBy: eventEntity?.username || "admin",
            modifiedBy: eventEntity?.username || "admin",
          });
        }
      });
    });

    if (payloads.length === 0) {
      toast.error("No guest or attendee found with allocated occasions.");
      return;
    }

    try {
      await Promise.all(
        payloads.map((body) => axios.post(trackInvites(), body))
      );
      toast.success("RSVP responses saved successfully.");
    } catch (error) {
      console.error("Failed to save RSVP responses", error);
      toast.error("Failed to save RSVP responses.");
    }
  };

  const filteredGuestWithAttendees = guestWithAttendees.filter((entry) => {
    const mainName = getFullName(entry.guest).toLowerCase();
    const matchesMain = mainName.includes(searchTerm.toLowerCase());

    const attendeeMatches = (entry.attendees || []).some((attendee) =>
      getFullName(attendee).toLowerCase().includes(searchTerm.toLowerCase())
    );

    return matchesMain || attendeeMatches;
  });

  // === Helpers for accurate table header stats ===
  const visibleRowsData = React.useMemo(() => {
    return filteredGuestWithAttendees
      .map((entry) => {
        const mainGuest = entry.guest;
        const attendees = entry.attendees || [];

        const mainKey = `${mainGuest._id}-null`;
        const mainAllocatedOccasions = selectedAllocations[mainKey] || [];

        const visibleAttendees = attendees
          .map((a) => {
            const key = `${mainGuest._id}-${a._id}`;
            const alloc = getRsvpAllocatedOccasions(key);
            return alloc.length > 0 ? { key, allocatedOccasions: alloc } : null;
          })
          .filter(Boolean);

        const showMain = hasRSVPAllocatedOccasion(mainKey) || visibleAttendees.length > 0;
        if (!showMain) return null;

        return {
          main: {
            key: mainKey,
            allocatedOccasions: getRsvpAllocatedOccasions(mainKey),
          },
          attendees: visibleAttendees,
        };
      })
      .filter(Boolean);
  }, [filteredGuestWithAttendees, selectedAllocations, occasions]);

  const { visibleMainCount, visibleAttendeeCount, totalVisibleRows } =
    React.useMemo(() => {
      const vm = visibleRowsData.length;
      const va = visibleRowsData.reduce((s, r) => s + r.attendees.length, 0);
      return {
        visibleMainCount: vm,
        visibleAttendeeCount: va,
        totalVisibleRows: vm + va,
      };
    }, [visibleRowsData]);

  const occasionStatsMap = React.useMemo(() => {
    const map = {};
    occasions.forEach((occ) => {
      let allocated = 0,
        yes = 0,
        no = 0,
        pending = 0,
        na = 0;

      visibleRowsData.forEach((row) => {
        const people = [row.main, ...row.attendees];
        people.forEach((p) => {
          const isAllocated = isAllocatedToOccasion(
            p.allocatedOccasions || [],
            occ._id
          );
          if (isAllocated) {
            allocated++;
            const resp = responseMap[p.key]?.[occ._id] ?? null;
            if (resp === "yes") yes++;
            else if (resp === "no") no++;
            else pending++;
          } else {
            na++;
          }
        });
      });

      map[occ._id] = { allocated, yes, no, pending, na };
    });
    return map;
  }, [occasions, visibleRowsData, responseMap]);

const handleExportRSVP = () => {
  if (!guestWithAttendees || guestWithAttendees.length === 0) {
    toast.error("No data available to export.");
    return;
  }

  try {
    const exportRows = [];

    // 1️⃣ Headers row
    const headers = [
      "Record Type",
      "Full Name",
      "Gender",
      "Relationship",
      "Attendee Type",
      "All",
      ...occasions.map((o) => o.OccasionName),
    ];
    exportRows.push(headers);

    // 2️⃣ Filter guest and attendees to export
    const filteredEntries = [];
    guestWithAttendees.forEach((entry) => {
      const mainKey = `${entry.guest._id}-null`;
      const mainAllocated = hasRSVPAllocatedOccasion(mainKey);

      const attendeeAllocated = entry.attendees.some((a) =>
        hasRSVPAllocatedOccasion(`${entry.guest._id}-${a._id}`)
      );

      if (mainAllocated || attendeeAllocated) {
        filteredEntries.push(entry);
      }
    });

    const totalGuests = filteredEntries.reduce(
      (sum, entry) => sum + (selectedAllocations[`${entry.guest._id}-null`]?.length > 0 ? 1 : 0),
      0
    );

    const totalAttendees = filteredEntries.reduce(
      (sum, entry) =>
        sum +
        entry.attendees.reduce(
          (attSum, a) =>
            attSum +
            (selectedAllocations[`${entry.guest._id}-${a._id}`]?.length > 0 ? 1 : 0),
          0
        ),
      0
    );

    const totalRecords = totalGuests + totalAttendees;

    const occasionCounts = occasions.map((occasion) => {
      let count = 0;
      filteredEntries.forEach((entry) => {
        const mainKey = `${entry.guest._id}-null`;
        if (isAllocatedToOccasion(getRsvpAllocatedOccasions(mainKey), occasion._id)) {
          count++;
        }

        (entry.attendees || []).forEach((attendee) => {
          const key = `${entry.guest._id}-${attendee._id}`;
          if (isAllocatedToOccasion(getRsvpAllocatedOccasions(key), occasion._id)) {
            count++;
          }
        });
      });
      return `${count}/${occasion.OccasionCapacity || "-"}`;
    });

    exportRows.push([
      totalRecords,
      `Guests: ${totalGuests}, Attendees: ${totalAttendees}`,
      "", "", "", "",
      ...occasionCounts,
    ]);

    // 3️⃣ Data rows – Apply same filtering logic
    filteredEntries.forEach((entry) => {
      const mainGuest = entry.guest;
      const fullNameMain = getFullName(mainGuest);
      const mainKey = `${mainGuest._id}-null`;
      const mainAllocations = getRsvpAllocatedOccasions(mainKey);

      if (mainAllocations.length > 0) {
        const mainOccasionResponses = occasions.map((o) => {
          if (isAllocatedToOccasion(mainAllocations, o._id)) {
            return (responseMap[mainKey]?.[o._id] || "N/A").toLowerCase();
          }
          return "N/A";
        });

        const mainAll = mainOccasionResponses.every((r) => r === "yes") ? "yes" : "";

        exportRows.push([
          "GUEST",
          fullNameMain,
          mainGuest.gender || "",
          "",
          "",
          mainAll,
          ...mainOccasionResponses.map((resp) => (resp === "n/a" ? "N/A" : resp)),
        ]);
      }

      entry.attendees
        .filter((attendee) => {
          const key = `${mainGuest._id}-${attendee._id}`;
          return hasRSVPAllocatedOccasion(key);
        })
        .forEach((attendee) => {
          const fullNameAtt = getFullName(attendee);
          const key = `${mainGuest._id}-${attendee._id}`;
          const attendeeAllocations = getRsvpAllocatedOccasions(key);

          const attendeeOccasionResponses = occasions.map((o) => {
            if (isAllocatedToOccasion(attendeeAllocations, o._id)) {
              return (responseMap[key]?.[o._id] || "N/A").toLowerCase();
            }
            return "N/A";
          });

          const attendeeAll =
            attendeeOccasionResponses.every((r) => r === "yes") ? "yes" : "";

          exportRows.push([
            "ATTENDEE",
            fullNameAtt,
            attendee.gender || "",
            attendee.relationWithMainMember || "",
            attendee.demographic || "",
            attendeeAll,
            ...attendeeOccasionResponses.map((resp) => (resp === "n/a" ? "N/A" : resp)),
          ]);
        });
    });

    const worksheet = XLSX.utils.aoa_to_sheet(exportRows);

    // --- Styles ---
    const headerStyle = {
      font: { bold: true },
      alignment: { horizontal: "center", vertical: "center" },
      fill: { fgColor: { rgb: "C6EFCE" } },
    };

    const totalsStyle = {
      font: { bold: true },
      alignment: { horizontal: "left", vertical: "left" },
      fill: { fgColor: { rgb: "FFEB9C" } },
    };

    headers.forEach((_, i) => {
      const cellRef = XLSX.utils.encode_cell({ r: 0, c: i });
      if (worksheet[cellRef]) worksheet[cellRef].s = headerStyle;
    });

    for (let c = 0; c < headers.length; c++) {
      const cellRef = XLSX.utils.encode_cell({ r: 1, c });
      if (worksheet[cellRef]) worksheet[cellRef].s = totalsStyle;
    }

    for (let r = 1; r < exportRows.length; r++) {
      for (let c = 0; c < headers.length; c++) {
        const cellRef = XLSX.utils.encode_cell({ r, c });
        if (!worksheet[cellRef]) continue;

        worksheet[cellRef].s = worksheet[cellRef].s || {};
        worksheet[cellRef].s.alignment = { horizontal: "left" };

        if (c > 5) {
          const cellValue = worksheet[cellRef].v.toLowerCase();
          if (cellValue === "yes") {
            worksheet[cellRef].s.fill = { fgColor: { rgb: "C6EFCE" } };
          } else if (cellValue === "no") {
            worksheet[cellRef].s.fill = { fgColor: { rgb: "FFC7CE" } };
          } else if (cellValue === "n/a") {
            worksheet[cellRef].s.fill = { fgColor: { rgb: "D9D9D9" } };
          }
        }
      }
    }

    const columnWidths = headers.map((_, colIndex) => {
      const maxLength = exportRows.reduce((max, row) => {
        const cell = row[colIndex];
        return Math.max(max, cell ? cell.toString().length : 10);
      }, 10);
      return { wch: maxLength + 2 };
    });
    worksheet["!cols"] = columnWidths;

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Guest Allocation");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
      cellStyles: true,
    });

    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "guest_allocation.xlsx";
    link.click();

    toast.success("Guest allocation exported successfully!");
  } catch (error) {
    console.error("Export failed:", error);
    toast.error("Failed to export guest allocation.");
  }
};





  return (
    <div className="container-fluid AllowAttendee">
      <div className="">
        <div className="occasion-top d-flex justify-content-between align-items-center">
        <h2 className="mb-0">RSVP</h2>
          <div style={{ maxWidth: "300px", width: "100%" }}>
            <input
              type="text"
              className="form-control mb-3"
              placeholder="Search Guest or Attendee Name..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-lg-12">
          <div className="border rounded shadow bg-white py-4 px-4">
            <div className="d-flex justify-content-between flex-wrap align-items-center mb-3">
              <h5 className="mb-2">RSVP</h5>
              <div className="d-flex gap-2">
                <button
                  className="btn btn-outline-secondary btn-sm event-btn"
                  onClick={() => navigate("/send-invites")}
                >
                  + Send Invite
                </button>
              </div>
            </div>

            <div className="table-responsive rsvp-table">
              <table className="table table-bordered align-middle table-hover">
                <thead className="thead-dark table-bg-new">
                  {/* Row 1: Labels */}
                  <tr>
                    <th>Sr No.</th>
                    <th>Guest Name</th>
                    {canEdit && (
                      <>
                        <th>Select All</th>
                        <th>Reset All</th>
                      </>
                    )}
                    {occasions.map((o) => (
                      <th className="text-center" key={o._id}>
                        {o.OccasionName}
                      </th>
                    ))}
                  </tr>

                  {/* Row 2: Counts */}
                  <tr>
                    <th>
                      <span className="text-sm text-gray-500">
                        ({totalVisibleRows})
                      </span>
                    </th>
                    <th>
                      <span className="text-sm text-gray-500">
                        (Guests: {visibleMainCount}, Attendees:{" "}
                        {visibleAttendeeCount})
                      </span>
                    </th>
                      {canEdit && (
                      <>
                    <th></th>
                    <th></th>
                    </>
                      )}
                    {occasions.map((o) => {
                      const stats = occasionStatsMap[o._id] || { allocated: 0 };
                      return (
                        <th className="text-center" key={`${o._id}-count`}>
                          <span className="text-sm text-gray-500">
                            ({stats.allocated} / {o.OccasionCapacity})
                          </span>
                        </th>
                      );
                    })}
                  </tr>

                  {/* Row 3: RSVP summary */}
                  <tr className="rsvp-stats-header-row">
                    <th></th>
                    <th></th>
                      {canEdit && (
                      <>
                    <th></th>
                    <th></th>
                    </>
                    )}
                    {occasions.map((o) => {
                      const {
                        yes = 0,
                        no = 0,
                        pending = 0,
                      } = occasionStatsMap[o._id] || {};
                      return (
                        <th key={`${o._id}-rsvp`} className="text-center">
                          <div className="d-flex justify-content-center">
                            <table className="rsvp-stats-table table-auto border border-gray-300 border-collapse mb-0">
                              <tbody>
                                <tr>
                                  <td className="border border-gray-300 px-2 py-1 bg-yes">
                                    Yes: {yes}
                                  </td>
                                  <td className="border border-gray-300 px-2 py-1 bg-no">
                                    No: {no}
                                  </td>
                                  <td className="border border-gray-300 px-2 py-1 bg-pending">
                                    Pending: {pending}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </th>
                      );
                    })}
                  </tr>
                </thead>

                <tbody>
                  {Array.isArray(guestWithAttendees) &&
        filteredGuestWithAttendees
  .filter((entry) => {
    const mainGuest = entry.guest;
    const attendees = entry.attendees || [];

    const mainKey = `${mainGuest._id}-null`;
    const mainAllocated = hasRSVPAllocatedOccasion(mainKey);

    const attendeeAllocated = attendees.some((attendee) => {
      const key = `${mainGuest._id}-${attendee._id}`;
      return hasRSVPAllocatedOccasion(key);
    });

    return mainAllocated || attendeeAllocated;
  })
                      .map((entry, index) => {
                        const mainGuest = entry.guest;
                        const attendees = entry.attendees || [];

                        const mainKey = `${mainGuest._id}-null`;
                        const mainAllocatedOccasions =
                          getRsvpAllocatedOccasions(mainKey);

                        const isSelectAllMain =
                          mainAllocatedOccasions.length > 0 &&
                          mainAllocatedOccasions.every(
                            (occId) => responseMap[mainKey]?.[occId] === "yes"
                          );

                        return (
                          <React.Fragment key={mainGuest?._id || index}>
                            {/* Main Guest Row */}
                            <tr className="table-primary">
                              <td>{index + 1}</td>
                              <td className="text-start">
                                {getFullName(mainGuest)}
                              </td>
                                {canEdit && (
                     <>
                              <td className="text-center">
                                <label className="custom-checkbox">
                                  <input
                                    type="checkbox"
                                    checked={isSelectAllMain}
                                    disabled={!canEdit}
                                    onChange={(e) =>
                                      handleSelectAllResponses(
                                        mainGuest._id,
                                        null,
                                        e.target.checked
                                      )
                                    }
                                  />
                                  <span className="checkmark"></span>
                                </label>
                              </td>
                    
                              <td className="text-center">
                                <button
                                  className="btn btn-sm btn-danger remove-btn"
                                  onClick={() =>
                                    setResponseMap((prev) => ({
                                      ...prev,
                                      [mainKey]: {},
                                    }))
                                  }
                                >
                                  Reset
                                </button>
                              </td>
                                </>)}
                              {occasions.map((occasion) => {
                                const selected = isAllocatedToOccasion(
                                  mainAllocatedOccasions,
                                  occasion._id
                                );
                                const response =
                                  responseMap[mainKey]?.[occasion._id] || null;

                                return (
                                  <td
                                    key={occasion._id}
                                    className="text-center"
                                  >
                                    {selected ? (
                                      renderRsvpChoice(
                                        mainKey,
                                        occasion._id,
                                        response
                                      )
                                    ) : (
                                      <span className="text-muted">N/A</span>
                                    )}
                                  </td>
                                );
                              })}
                            </tr>

                            {/* Attendee Rows */}
                            {attendees
                              .filter((attendee) => {
                                const key = `${mainGuest._id}-${attendee._id}`;
                                return hasRSVPAllocatedOccasion(key);
                              })
                              .map((attendee, subIndex) => {
                                const key = `${mainGuest._id}-${attendee._id}`;
                                const allocatedOccasions =
                                  getRsvpAllocatedOccasions(key);

                                const isSelectAllAttendee =
                                  allocatedOccasions.length > 0 &&
                                  allocatedOccasions.every(
                                    (occId) =>
                                      responseMap[key]?.[occId] === "yes"
                                  );

                                return (
                                  <tr
                                    key={attendee._id || `attendee-${subIndex}`}
                                    className="table-secondary text-sm"
                                  >
                                    <td>{`${index + 1}.${subIndex + 1}`}</td>
                                    <td className="text-start pl-4">
                                      {getFullName(attendee)}{" "}
                                      <span className="text-muted">
                                        (
                                        {attendee.relationWithMainMember ||
                                          "Attendee"}
                                        )
                                      </span>
                                    </td>
                                     {canEdit && (
                                <>
                                    <td className="text-center">
                                      <label className="custom-checkbox">
                                        <input
                                          type="checkbox"
                                          checked={isSelectAllAttendee}
                                          disabled={
                                            !canEdit
                                          }
                                          onChange={(e) =>
                                            handleSelectAllResponses(
                                              mainGuest._id,
                                              attendee._id,
                                              e.target.checked
                                            )
                                          }
                                        />
                                        <span className="checkmark"></span>
                                      </label>
                                    </td>
                                    <td className="text-center">
                                      <button
                                        className="btn btn-sm btn-danger remove-btn"
                                        onClick={() =>
                                          setResponseMap((prev) => ({
                                            ...prev,
                                            [key]: {},
                                          }))
                                        }
                                      >
                                        Reset
                                      </button>
                                    </td>
                                    </>
                                     )}
                                    {occasions.map((occasion) => {
                                      const selected = isAllocatedToOccasion(
                                        allocatedOccasions,
                                        occasion._id
                                      );
                                      const response =
                                        responseMap[key]?.[occasion._id] ||
                                        null;

                                      return (
                                        <td
                                          className="text-center"
                                          key={occasion._id}
                                        >
                                          {selected ? (
                                            renderRsvpChoice(
                                              key,
                                              occasion._id,
                                              response
                                            )
                                          ) : (
                                            <span className="text-muted">
                                              N/A
                                            </span>
                                          )}
                                        </td>
                                      );
                                    })}
                                  </tr>
                                );
                              })}
                          </React.Fragment>
                        );
                      })}
                </tbody>
              </table>
            </div>

            {canEdit && (
              <div className="page-actions-bar d-flex justify-content-center gap-2">
                <button
                  type="submit"
                  className="btn btn-success btn-save"
                  onClick={handleSubmit}
                >
                  Save
                </button>

                <button
                  type="reset"
                  className="btn excel-btn"
                  onClick={handleExportRSVP}
                >
                  Export to Excel <i className="bi bi-download"></i>
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default RSVP;
